import React from 'react';
import { useState } from 'react';
import CreateDocuments from '../../Components/layouts/AdminDashboard/Documents/CreateDocuments';
import DocumentsInfo from '../../Components/layouts/AdminDashboard/Documents/DocumentsInfo';
import EmptyCourseDash from '../../Components/share/EmptyCourseDash/EmptyCourseDash';
import { Modal } from '../../Components/share/modal/Modal';
import useFetch from '../../Hooks/useFetch';

function Document() {
	const [displayDocument, setDisplayDocument] = useState(false);
	const [isModalVisible, setModalVisible] = useState(false);

	const [documentList, setDocumentList] = useState([]);
	const [selectedDocument, setSelectedDocument] = useState({});

	const handleModalVisible = () => {
		setModalVisible((prev) => !prev);
	};

	const handleSelectedDocument = (doc) => {
		setSelectedDocument(doc);
		setModalVisible(true);
	};
	const getDocumentList = useFetch({
		method: 'GET',
		url: `CertificateService/11/bootcamp_certificates`,
		noHeader: false,
		trigger: true,
		setter: (data) => {
			setDocumentList(data.results);
			setSelectedDocument({});
		},
	});

	return (
		<div>
			{!documentList.length ? (
				<EmptyCourseDash
					name='مدارک'
					handleModalVisible={handleModalVisible}
				/>
			) : (
				<DocumentsInfo
					documentList={documentList}
					handleModalVisible={handleModalVisible}
					refreshList={getDocumentList}
					handleSelectedDocument={handleSelectedDocument}
				/>
			)}

			<Modal show={isModalVisible} close={handleModalVisible}>
				<CreateDocuments
					close={handleModalVisible}
					refreshList={getDocumentList}
					selectedDocument={selectedDocument}
				/>
			</Modal>
		</div>
	);
}

export default Document;
